import { ACCOUNT_STATUS_ACTIVE, ACCOUNT_STATUS_PENDING_ACCOUNT_SETUP, ACCOUNT_STATUS_PENDING_MEMBER_SETUP } from './constants';
import { convertFirebaseTimestampsToDate } from './dateHelper';

import _get from 'lodash/get';
import _pick from 'lodash/pick';
import _find from 'lodash/find';
import _reduce from 'lodash/reduce';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _sortBy from 'lodash/sortBy';

export const getIsEmpBadgeByEmpData = empData => {
    const tier = empData?.tier;
    return tier === 3;
};

export const getTotalEngagementMax = ({ tier = 1, billMonthly = true, jsEngageMax = 0, activeJobMax = 0 }) => {
    const monthlyMax = jsEngageMax * activeJobMax;
    return tier === 3 ? null : billMonthly ? monthlyMax : monthlyMax * 12;
};

export const getTotalEngagementMaxByTiersData = ({ tier = 1, billMonthly = true, tiers }) => {
    if (tier === 3) {
        return null;
    } else {
        const tierData = _get(tiers, `[${tier - 1}]`);
        const jsEngageMax = tierData?.jsEngageMax || 0;
        const activeJobMax = tierData?.activeJobMax || 0;

        return getTotalEngagementMax({ tier, billMonthly, jsEngageMax, activeJobMax });
    }
};

export const getEngagementRemainingCountByEmployerTiersData = ({ currentEmployer, tiers }) => {
    const tier = _get(currentEmployer, 'tier', 1);
    const billMonthly = _get(currentEmployer, 'billMonthly', false);
    if (tier === 3) {
        return null;
    } else {
        const totalEngageMax = getTotalEngagementMaxByTiersData({ tier, billMonthly, tiers });
        const jsEngageCount = _get(currentEmployer, 'jsEngageCount', 0);
        const remainingCount = totalEngageMax - jsEngageCount;
        return remainingCount < 0 ? 0 : remainingCount;
    }
};

/**
 * @deprecated since 2022-07-12
 */
export const getEngagementRemainingCountByJsEngageCount = ({ currentEmployer, tiers, jsEngageCount = 0 }) => {
    const tier = _get(currentEmployer, 'tier', 1);
    if (tier === 3) {
        return null;
    } else {
        const jsEngageMax = _get(tiers, `[${tier - 1}].jsEngageMax`, 0);
        const remainingCount = jsEngageMax - jsEngageCount;
        return remainingCount < 0 ? 0 : remainingCount;
    }
};

export const convertEmployerTimestampsToDate = data => {
    //TODO billAttemptDts[]
    //TODO members[] inviteDt
    //TODO membersNew[] inviteDt
    return convertFirebaseTimestampsToDate(data, [
        'additionalSeatBillCycleStartDt',
        'additionalSeatBillCycleEndDt',
        'additionalSeatSubscriptionDt',
        'additionalSeatUnsubscribeDt',
        'billCycleStartDt',
        'billCycleEndDt',
        'currentMonthStartDt',
        'downgradeAdditionalSeatsDt',
        'downgradeSubscriptionDt',
        'prevStripeCusCreateDt',
        'seatPurchasedDt',
        'stripeCusCreateDt',
        'subscriptionDt',
        'unsubscribeDt',
    ]);
};

export const mapToEmpJob = (dto = {}) => {
    return {
        active: dto.active,
        activeDt: dto.activeDt,
        benefitSummary: dto.benefitSummary,
        city: dto.city,
        cityLocation: dto.cityLocation,
        comingSoon: dto.comingSoon,
        companyBio: dto.companyBio,
        companyName: dto.companyName,
        companyProfilePicUrl: dto.companyProfilePicUrl,
        country: dto.country,
        createDt: dto.createDt,
        currency: dto.currency,
        currencySymbol: dto.currencySymbol,
        education: dto.education,
        employmentType: dto.employmentType,
        filled: dto.filled,
        inactiveDt: dto.inactiveDt,
        intern: dto.intern,
        isEmpBadge: dto.isEmpBadge,
        isExactRate: dto.isExactRate,
        jobApplicationUrl: dto.jobApplicationUrl,
        jobDescription: dto.jobDescription,
        jobTitle: dto.jobTitle,
        otherEducation: dto.otherEducation,
        payFrequency: dto.payFrequency,
        parentId: dto.employerId,
        rateMax: dto.rateMax,
        rateMin: dto.rateMin,
        reqNum: dto.reqNum,
        state: dto.state,
        statusDt: dto.statusDt,
        telework: dto.telework,
        updateDt: dto.updateDt,
        yrsOfExp: dto.yrsOfExp,
    };
};

export const getIsAccountSwitchable = ({ idx, status }) => {
    const isActive = status === ACCOUNT_STATUS_ACTIVE;
    const isPendingAccountSetup = status === ACCOUNT_STATUS_PENDING_ACCOUNT_SETUP;
    const isPendingMemberSetup = status === ACCOUNT_STATUS_PENDING_MEMBER_SETUP;

    return isActive || isPendingAccountSetup || isPendingMemberSetup || idx === 0;
};

export const getUserInfoByEmployerId = ({ currentUser, employerId } = {}) => {
    const employer = _find(currentUser?.employers, item => item.employerId === employerId);
    return _pick(employer, ['firstName', 'middleName', 'lastName', 'profilePicUrl', 'country', 'state', 'city', 'cityLocation']);
};

export const getEngagementTotalListByJobTitle = engagements => {
    const engagementTotals = _reduce(
        engagements,
        (totals, engagement) => {
            if (totals[engagement.jobTitle]) totals[engagement.jobTitle] += 1;
            else totals[engagement.jobTitle] = 1;

            return totals;
        },
        {},
    );

    return _map(_sortBy(_keys(engagementTotals)), jobTitle => ({ jobTitle, total: engagementTotals[jobTitle] }));
};

export const getEmployerDataForActiveJob = ({ employer, profile }) => {
    const companyName = _get(employer, 'companyName');
    const companyProfilePicUrl = _get(employer, 'profilePicUrl');
    const tier = _get(employer, 'tier');
    const isEmpBadge = tier === 3;
    const benefitSummary = _get(profile, 'info.benefit', '');
    const companyBio = _get(profile, 'info.bio', '');

    return { companyName, companyProfilePicUrl, benefitSummary, companyBio, isEmpBadge };
};
